function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}
function getCompany(subject, company) {
  switch (subject) {
    case "legal":
      return `ЮЛ, ${company.name_legal}`;
    case "physical":
      return `ФЛ, ${company.lastname} ${company.name && company.name[0]}. `;
    case "individ":
      return company.name_legal;
    default:
      return null;
  }
}

const progresses = {};

progresses.default = [
  {
    title: "Заказчик",
    name: "customer",
    completed: false,
    fields: [
      "customerCompany"
      // , "lastname", "name", "patronymic", "nameLegal"
    ],
    check: (values, form) => {
      return !!values.customerCompany;
    },
    getDescription: (values, props) => {
      const selectedCompany = props.customerCompanies.find(
        item => item.profile_id === values.customerCompany
      );
      return getCompany(selectedCompany.subject.subject_key, {
        ...selectedCompany
      });
    }
  },
  {
    title: "Описание услуги",
    name: "serviceType",
    fields: [
      "serviceType",
      "passengersCount",
      "kidsCount",
      "accompCount",
      "orderName"
    ],
    completed: false,
    check: (values, form) => {
      switch (values.serviceType) {
        case "kids": {
          return !!(
            !hasErrors(
              form.getFieldsError(["serviceType", "kidsCount", "accompCount"])
            ) &&
            values.kidsCount &&
            values.accompCount
          );
        }
        case "undefined": {
          return !!(
            !hasErrors(form.getFieldsError(["serviceType"])) &&
            values.serviceType
          );
        }
        case "simple": {
          return !!(
            !hasErrors(
              form.getFieldsError(["serviceType", "passengersCount"])
            ) &&
            values.serviceType &&
            values.passengersCount
          );
        }
        default:
          return null;
      }
    },
    getDescription: (values, props) => {
      let val = [];
      if (values.serviceType && props.serviceTypes) {
        let type = props.serviceTypes.find(
          item => item.serviceTypeKey === values.serviceType
        );
        if (type) {
          if (type.serviceTypeAbbr) val.push(type.serviceTypeAbbr);
          if (type.serviceTypeKey === "kids") {
            if (values.accompCount || values.kidsCount) {
              val.push(
                (values.accompCount ? values.accompCount : 0) +
                  (values.kidsCount ? values.kidsCount : 0) +
                  " пасс."
              );
            }
          } else {
            if (values.passengersCount)
              val.push(`${values.passengersCount} пасс.`);
          }
        }
      }

      if (values.orderName) val.push(`«${values.orderName}»`);
      // let val = `${values.phoneCode}${values.phone}, ${values.email}`;
      return val.length > 0 ? val.join(", ") : null;
    }
  },
  {
    title: "Программа маршрута",
    name: "routeProgram",
    fields: ["arrivalDatetime", "routes"],
    completed: false,
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(["arrivalDatetime"])) &&
        values.arrivalDatetime &&
        values.routes &&
        values.routes.length > 1
      );
    },
    getDescription: values => {
      return (
        values.arrivalDatetime.format("DD.MM.YYYY") +
        " ," +
        values.arrivalDatetime.format("HH:mm")
      );
    }
  },
  {
    title: "Статус заказа и исполнитель",
    name: "performer",
    fields: [
      "performer",
      "performerName",
      "vehicle",
      "vehicleId",
      "dispatcher"
    ],
    completed: false,
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(["performer"])) &&
        values.performer &&
        !hasErrors(form.getFieldsError(["dispatcher"])) &&
        values.dispatcher &&
        !hasErrors(form.getFieldsError(["vehicle"])) &&
        values.vehicle &&
        !hasErrors(form.getFieldsError(["vehicleId"])) &&
        values.vehicleId
      );
    },
    getDescription: values => {
      return values.performerName;
    }
  },
  {
    title: "Монетизация",
    name: "monetization",
    fields: [
      "t2",
      "t4",
      "t6",
      "t7",
      "t8",
      "t9",
      "sh1",
      "sh2",
      "sh3",
      "kp1t",
      "kp1p",
      "kp2t",
      "kp2p",
      "kp3t",
      "kp3p",
      "kp4t",
      "kp4p",
      "kz1t",
      "kz1p",
      "kz2t",
      "kz2p",
      "kz3t",
      "kz3p",
      "kz4t",
      "kz4p",
      "kp1urc",
      "monetizationIsPassed"
    ],
    check: (values, form) => {
      return (
        Object.values(values).some(item => item) || values.monetizationIsPassed
      );
    },
    completed: false
  },
  {
    title: "Цена заказа",
    name: "price",
    fields: ["priceNoNds", "totalPrice", "priceFinalNDS", "additionalServices"],
    check: (values, form) => {
      return (
        !hasErrors(form.getFieldError(["priceNoNds"])) && !!values.priceNoNds
      );
    },
    completed: false,
    getDescription: (values, props) => {
      return `${values.totalPrice} ₽ ${
        values.priceFinalNDS > 0 ? "с НДС" : "без НДС"
      }, ${
        values.additionalServices && values.additionalServices.length > 0
          ? `${values.additionalServices.length} доп. услуги`
          : "без доп. услуг"
      }`;
    }
  },
  {
    title: "Способ оплаты",
    name: "payment",
    fields: [
      "predPay",
      "pay",
      "postPay",
      "predPayPrice0",
      "payPrice",
      "postPayPrice0"
    ],
    check: values => {
      return (
        (values.predPay && values.predPay.length > 0 && values.predPayPrice0) ||
        (values.pay && values.pay.length > 0 && values.payPrice) ||
        (values.postPay && values.postPay.length > 0 && values.postPayPrice0)
      );
    },
    completed: false,
    getDescription: value =>
      `${(value.predPay &&
        value.predPay.length > 0 &&
        value.predPayPrice0 &&
        "Предоплата") ||
        ""} ${
        value.pay && value.pay.length > 0
          ? value.predPay && value.predPay.length > 0 && value.predPayPrice0
            ? ", при посадке"
            : "При посадке"
          : ""
      } 
        ${
          value.postPay && value.postPay.length > 0 && value.postPayPrice0
            ? value.pay &&
              value.pay.length > 0 &&
              value.payPrice &&
              value.predPay &&
              value.predPay.length > 0 &&
              value.predPayPrice0
              ? ", пост оплата"
              : "Пост оплата"
            : ""
        }
      `
  },
  {
    title: "Доплаты",
    name: "surcharge",
    fields: ["priceAddPayment"],
    check: values => {
      return !!values.priceAddPayment;
    },
    completed: false
  },
  {
    title: "Документы системы",
    name: "offerDocument",
    fields: ["responsibleDocumentsKeyList"],
    check: values => {
      return (
        values.responsibleDocumentsKeyList &&
        values.responsibleDocumentsKeyList.length > 0
      );
    },
    completed: false,
    button: false
  }
];

export default progresses;
